module.exports = __webpack_public_path__ + "img/pt-11.3579c329.jpg";